












































































































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import AssignmentGroups from '@/views/browse-and-go/components/AssignmentGroups.vue'
import { AssignmentRow, buildAssignmentView } from '@/services/browse-and-go/assignment-view'
import { ClientAssignmentSummary, effectiveProgramId, summarizeClient } from '@/services/browse-and-go/effective'
import { normalizeSearch } from '@/services/browse-and-go/labels'
import {
  bngState,
  setBenefitProgram,
  setCardExceptions,
  setExpertMode,
  setOperationException
} from '@/services/browse-and-go/store'
import { ClientPro } from '@/services/browse-and-go/types'

@Component({
  name: 'BrowseAndGoAssignments',
  components: { PageHeader, AssignmentGroups }
})
export default class extends Vue {
  private registerQuery = ''
  private clientQuery = ''
  private selectedId = ''

  get rows() {
    const needle = normalizeSearch(this.registerQuery)
    return bngState.clients
      .map(client => summarizeClient(bngState, client))
      .filter(row => row.visible)
      .filter(row => {
        if (!needle) return true
        return normalizeSearch(row.client.name).includes(needle) || normalizeSearch(row.client.id).includes(needle)
      })
  }

  get selectedClient(): ClientPro | null {
    return bngState.clients.find(client => client.id === this.selectedId) || null
  }

  get view() {
    if (!this.selectedClient) return null
    return buildAssignmentView(bngState, this.selectedClient)
  }

  get programs() {
    return bngState.programs
  }

  get programId() {
    if (!this.selectedClient) return ''
    return effectiveProgramId(bngState, this.selectedClient) || ''
  }

  private summaryLine(row: ClientAssignmentSummary) {
    const parts: string[] = []
    if (row.removedCards.length) parts.push(`Cartes retirées : ${row.removedCards.join(', ')}`)
    if (row.addedCards.length) parts.push(`Cartes ajoutées : ${row.addedCards.join(', ')}`)
    if (row.removedOperations.length) parts.push(`Opérations retirées : ${row.removedOperations.join(', ')}`)
    if (row.addedOperations.length) parts.push(`Opérations ajoutées : ${row.addedOperations.join(', ')}`)
    if (row.programLabel) parts.push(`Programme : ${row.programLabel}`)
    return parts.join(' · ')
  }

  private suggestClients(query: string, done: (rows: Array<ClientPro & { value: string }>) => void) {
    const needle = normalizeSearch(query)
    done(
      bngState.clients
        .filter(client => !needle || normalizeSearch(client.name).includes(needle) || normalizeSearch(client.id).includes(needle))
        .map(client => ({ ...client, value: client.name }))
    )
  }

  private onSelectClient(client: ClientPro) {
    this.selectedId = client.id
    this.clientQuery = ''
  }

  private clearClient() {
    this.selectedId = ''
    this.clientQuery = ''
  }

  private focusEditor(clientId?: string) {
    if (clientId) this.selectedId = clientId
    this.$nextTick(() => {
      const editor = this.$refs.editor as Vue | undefined
      const element = editor && editor.$el ? editor.$el as HTMLElement : null
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }

  private onRow(row: AssignmentRow) {
    if (!this.selectedClient) return
    const enabled = !row.applied
    if (row.target === 'cards') {
      setCardExceptions(this.selectedClient.id, row.ids, row.action, enabled)
      return
    }
    setOperationException(this.selectedClient.id, row.ids[0], row.action, enabled)
  }

  private onProgramChange(programId: string) {
    if (!this.selectedClient) return
    setBenefitProgram(this.selectedClient.id, programId)
  }

  private toggleExpert() {
    if (!this.selectedClient) return
    setExpertMode(this.selectedClient.id, !this.selectedClient.expertMode)
  }
}
